import { ObjectId, ObjectType } from '../object.model';
import {UserId} from '../user';

export enum Role {
  ADMIN = 'admin',
  CONFIGURER = 'configurer',
  OWNER = 'owner',
  RESPONDER = 'responder',
  VALUE_READER = 'value_reader',
  VALUE_WRITER = 'value_writer'
}

export enum RoleLabel {
  ADMIN = 'Admin',
  CONFIGURER = 'Configurer',
  OWNER = 'Owner',
  RESPONDER = 'Responder',
  VALUE_READER = 'Value Reader',
  VALUE_WRITER = 'Value Writer'
}

export interface PillOption<K = string> {
  key: K;
  label: string;
}

export const RoleOptions: PillOption<Role>[] = [
  { key: Role.ADMIN, label: RoleLabel.ADMIN },
  { key: Role.CONFIGURER, label: RoleLabel.CONFIGURER },
  { key: Role.RESPONDER, label: RoleLabel.RESPONDER },
  { key: Role.VALUE_READER, label: RoleLabel.VALUE_READER },
  { key: Role.VALUE_WRITER, label: RoleLabel.VALUE_WRITER }
];

// Helper function to convert Role to PillOption<Role>
export function roleToPillOption(role: Role): PillOption<Role> {
  const found = RoleOptions.find(opt => opt.key === role);
  return found ? { key: found.key, label: found.label } : { key: role, label: role };
}

// Helper function to convert array of Roles to PillOption<Role>[]
export function rolesToPillOptions(roles: Role[]): PillOption<Role>[] {
  return roles.map(roleToPillOption);
}

export interface AssignRolesRequest {
  UserID: UserId;
  ObjectID: ObjectId;
  ObjectType: ObjectType;
  Roles: Role[];
}
